import SFAuthService, { NO_USER } from 'app/services/sfAuth/SFAuthService'
import { backendParsers, queryCreateObject } from '../Common'
import { CommonFlowResult } from '../salesforce-maps/CommonTypes'
import { ErrorLog } from '../salesforce-maps/ErrorLog'
import { FundingStream, fundingStreamFieldsMapSF } from '../salesforce-maps/FundingStream'
import { reverseMap } from 'app/services/sfAuth/sfDataService'

const reversedFundingStreamMap = reverseMap(fundingStreamFieldsMapSF)

/**
 * Creates an Error Log record when a required funding stream field is missing.
 * @param field - The FundingStream JS property that was empty (e.g. 'quiz'). Resolved to its Salesforce field name automatically.
 * @param path - The application path where the missing field was detected (e.g. history.location.pathname)
 * @param salesforceId - The Salesforce ID of the funding stream
 */
export const createFundingStreamFieldErrorLog = (
  field: keyof FundingStream | string,
  path: string,
  salesforceId?: string
): void => {
  const mapped = reversedFundingStreamMap[field]
  const salesforceField = typeof mapped === 'string'
    ? mapped
    : typeof mapped === 'object' && mapped !== null
      ? mapped.key
      : field
  queryCreateObject({
    type: 'Error Log',
    createData: {
      severity: 'error',
      description: path,
      longDescription: JSON.stringify({ missingFundingStreamField: salesforceField, salesforceId })
    }
  }).catch(error => {
    console.error('Failed to create funding stream field error log:', error)
  })
}

export const updateErrorLogByFlow = async (
  toUpdate: Partial<ErrorLog> & { id: string } | Array<Partial<ErrorLog> & { id: string }>
): Promise<CommonFlowResult[]> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return await conn.requestPost('/actions/custom/flow/App_Update_Error_Log', {
    inputs: [
      {
        toUpdate: Array.isArray(toUpdate)
          ? toUpdate.map(obj => (backendParsers['Error Log'].Salesforce.out(obj)))
          : [
              backendParsers['Error Log'].Salesforce.out(toUpdate)
            ]
      }
    ]
  })
}
